<template>
  <div>
    <div class="wraper">
      <!-- HEADER -->
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <div class="row myrow">
          <div class="col-xs-12 mycol header-title header-title-transpatrent">
            <div class="stl-df-ac stl-df-jsb page-title-wrapper">
              <div class="page-title-container">
                <div class="stl-fw-bold page-title-container__title">
                  {{ listQuestionConference.TITLE_PAGE }}
                </div>
                <div>
                  <span class="stl-fw-bold">Дата заседания:</span>
                  {{ listQuestionConference.DATE_PAGE }}
                  <span class="stl-fw-bold">Место проведения:</span>
                  <span v-html="listQuestionConference.PLACE"></span>
                </div>
              </div>
              <div
                class="stl-df-ac conference-mobile-stl-control"
                v-if="listQuestionConference.IS_VIEW_BUTTON_CHANGE_MODE"
              >
                <span class="stl-fw-bold stl-mr-10">
                  Вид страницы голосования:</span
                >
                <div class="switch-container stl-mr-10">
                  <span
                    class="switch-text switch-text-no"
                    :class="{
                      checked: isConf
                    }"
                  >
                    Текущее заседание
                  </span>
                  <label class="switch-box">
                    <input type="checkbox" v-model="isConf" />
                    <span
                      class="switch-box__slider switch-box__slider2 switch-box__round"
                    ></span>
                  </label>
                  <span
                    class="switch-text switch-text-yes"
                    :class="{
                      checked: !isConf
                    }"
                  >
                    Голосование
                  </span>
                </div>
                <button
                  v-if="listQuestionConference.IS_VIEW_GENERATE_BUTTON_VIEW"
                  class="butt-stl butt-blue"
                  @click="getLinkReport"
                  type="button"
                >
                  Генерация повестки
                </button>

                <a
                  href="https://conferencefrprf.bitrix24.site/"
                  target="_blank"
                  class="butt-stl butt-blue stl-ml-10"
                >
                  Стандарты по программам
                </a>
              </div>

              <div class="stl-df-ac conference-mobile-stl-control" v-else>

                <button
                  v-if="listQuestionConference.IS_VIEW_BUTTON_PRINT_BILLUTEN"
                  class="butt-stl butt-green"
                  :class="
                    listQuestionConference.IS_VIEW_BUTTON_PRINT_BILLUTEN_DISABLED
                      ? ' butt-vote-disabled'
                      : ''
                  "
                  @click="getLinkExportBilluten"
                  :disabled="
                    listQuestionConference.IS_VIEW_BUTTON_PRINT_BILLUTEN_DISABLED
                      ? true
                      : false
                  "
                  type="button"
                >
                  Печать бюллетени
                </button>

                <a
                  href=" https://conferencefrprf.bitrix24.site/"
                  target="_blank"
                  class="butt-stl butt-blue stl-ml-10"
                >
                  Стандарты по программам
                </a>
              </div>

              <div class="stl-df-ac conference-mobile-stl-control" style="padding-top: 10px;">
                <a
                  href="https://bod.frprf.ru/public/documents/usloviya-finansirovaniya-proektov-po-programme-omp"
                  target="_blank"
                  class="link"
                >
                  Стандарт мобилизации
                </a>&nbsp;
                <a
                  href="https://bod.frprf.ru/public/documents/prezentaciya-programmy-omp"
                  target="_blank"
                >
                  Презентация мобилизации
                </a>&nbsp;
                <a
                  href="https://bod.frprf.ru/public/documents/kriterii-finansovogo-sostoyaniya-zayavitelya-po-programme-obespechenie-mobilizacionnykh-potrebnostejj"
                  target="_blank"
                >
                  Критерии финансового состояния заявителя мобилизация
                </a>&nbsp;
                <a
                  href="https://bod.frprf.ru/public/documents/napravleniya-celevogo-ispolzovaniya-sredstv-finansirovaniya-proekta-po-programme-omp"
                  target="_blank"
                >
                  Направления ЦРС мобилизация
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- HEADER -->
      <ConferencePage v-if="isConf" />
      <VotingPage v-else />
    </div>
    <!-- wraper -->
    <!-- FOTER -->
    <div class="footer footer-fix" style="z-index: 5;">
      <div class="container-fluid mycontainer-fluid">
        <div class="myfooter">
          <div class="myfooter-frp"></div>
        </div>
      </div>
    </div>
    <!-- FOTER -->
  </div>
</template>

<script>
import {
  SET_MAIN_MENU,
  SET_IS_VIEW_ALL_EXPERTISE,
  FETCH_LIST_QUESTION_CONFERENCE
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import { ProjectsService, ExpertAdvice } from "@/common/api.service";
import ConferencePage from "@/components/expert/Conference/ConferencePage.vue";
import VotingPage from "@/components/expert/Conference/VotingPage.vue";
import { AUTH_URL } from "@/common/config";

export default {
  name: "Conference",
  components: { VotingPage, ConferencePage },
  title: "Советы",
  data() {
    return {
      isConf: true,
      filter: {
        MODE: "current_meeting"
      },
      setPhilter: false
    };
  },
  computed: {
    ...mapGetters([
      "listQuestionConference",
      "isListQuestionConference",
      "directory",
      "currentUser"
    ])
  },
  async mounted() {
    await this.$store.dispatch(SET_MAIN_MENU, []);
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          /*if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }*/
          if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }
          if (
            data.IS_VIEW_VOTE_SOVETE_MODULE &&
            data.IS_VIEW_VOTE_SOVETE_MENU
          ) {
            navMainMenu.push({
              name: "Заседания",
              route: "Conference"
            });
          }
          /*if (
            this.currentUser.ACTIVE_ROLE_CODE != "member_ec" &&
            this.currentUser.ACTIVE_ROLE_CODE != "member_nc"
          ) {
            navMainMenu.push({
              name: "Запросы",
              route: "Requests"
            });
          }*/
        } else {
          if (
            data.IS_VIEW_VOTE_SOVETE_MODULE &&
            data.IS_VIEW_VOTE_SOVETE_MENU
          ) {
            navMainMenu.push({
              name: "Заседания",
              route: "Conference"
            });
          }
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          /*if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }*/
          if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }
          if (data.IS_VIEW_SUBMITTED_PROJECTS) {
            navMainMenu.push({
              name: "Вынесенные проекты",
              route: "SubmittedProjects"
            });
          }
          /*if (
            this.currentUser.ACTIVE_ROLE_CODE != "member_ec" &&
            this.currentUser.ACTIVE_ROLE_CODE != "member_na"
          ) {
            navMainMenu.push({
              name: "Запросы",
              route: "Requests"
            });
          }*/
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
      });
    } else {
      await this.$store.dispatch(SET_MAIN_MENU, [
        {
          name:
            this.currentUser.TYPE_USER === "manager"
              ? "Реестр проектов"
              : "Мои проекты",
          route: "Projects"
        }
      ]);
    }

    if (this.$route.query.mode == "voting") {
      this.filter.MODE = this.$route.query.mode;
    }

    this.fetchItems();
  },
  methods: {
    moveBack() {
      this.$router.push({
        name: "EAList",
        params: { id: this.$route.params.id }
      });
    },
    fetchItems() {
      this.$store
        .dispatch(FETCH_LIST_QUESTION_CONFERENCE, {
          idSovet: this.$route.params.id,
          filter: { ...this.filter }
        })
        .then(() => {
          document.title = unescape(this.listQuestionConference.TITLE_PAGE);
          this.isConf = this.listQuestionConference.MODE === "current_meeting";

          if (this.listQuestionConference.SP_TYPE_SOVET) {
            if (this.listQuestionConference.SP_TYPE_SOVET.length == 1) {
              this.filter.UF_TYPE_SOVET_ID = this.listQuestionConference.SP_TYPE_SOVET[0].ID;
            }
          }
        }, this);
    },
    getLinkReport() {
      window.open(
        "http://reporting/reports/report/%D0%9E%D1%82%D1%87%D0%B5%D1%82%D1%8B/%D0%94%D0%9F/%D0%93%D0%B5%D0%BD%D0%B5%D1%80%D0%B0%D1%86%D0%B8%D1%8F%20%D0%BF%D0%BE%D0%B2%D0%B5%D1%81%D1%82%D0%BA%D0%B8%20%D0%AD%D0%A1",
        "_blank"
      );
    },
    getLinkExportBilluten() {
      ExpertAdvice.getLinkExportBilluten(
        this.listQuestionConference.EXPERT_SOVET_ID
      ).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    }
  }
};
</script>
